import Button from 'components/Button';
import Error from 'components/form/Error';
import Space from 'components/Space';
import { MenteeStatusValues } from 'enums/MenteeStatus';
import { FC, useContext, useState } from 'react';
import styled from 'styled-components';
import { mutate } from 'swr';
import privateAPI from 'utils/privateAxiosInstance';
import { MenteeEditContext } from '..';

const Text = styled.p`
  color: var(--gray-700);
  font-weight: 500;
  b {
    font-weight: 700;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1rem;

  & > * {
    margin-right: 0.75rem;
  }
`;

const Refused: FC = () => {
  const { mentee } = useContext(MenteeEditContext);

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const handleSetElligible = () => {
    setLoading(true);
    setError('');
    privateAPI
      .patch(`/user/status/${mentee?.id}`, {
        menteeStatus: 'ELIGIBLE' as MenteeStatusValues,
      })
      .then(() => {
        mutate(`/user/${mentee!.id}`);
        mutate(`/mentorship/mentee/${mentee!.id}`);
        mutate(`/mentorship/mentee/${mentee!.id}/ongoing`);
      })
      .catch(() => {
        setError('Une erreur est survenue.');
      })
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <Text>
        Le mentorat a été refusé par l'administrateur.
        <br />
        Modifiez le statut du mentoré à "<b>Admissible au mentorat</b>" pour lui
        associer un mentor.
      </Text>
      <ButtonsContainer>
        <Button color="primary" onClick={handleSetElligible} loading={loading}>
          Modifier le statut
        </Button>
      </ButtonsContainer>
      {error && (
        <>
          <Space height={0.5} />
          <Error>{error}</Error>
        </>
      )}
    </div>
  );
};

export default Refused;
